import { createContext, useContext } from "react";

export type SceneContextType = {
  setSkyColor: (color: string) => void;
};

export const SceneContext = createContext<SceneContextType>({
  setSkyColor: () => {},
});

export const {
  Provider: SceneContextProvider,
  Consumer: SceneContextConsumer,
} = SceneContext;

export const useSceneContext = () => useContext(SceneContext);
